import { Icon, withTooltip } from 'vetrf-ui';

export const IconWithTooltip = withTooltip(Icon);
